/**
 * Session counters for save coordinator outcomes, included in sampled canvas-load logs only (no payloads).
 */

export type SaveTelemetry = {
  parked: number
  failed: number
  retries: number
}

let counters: SaveTelemetry = { parked: 0, failed: 0, retries: 0 }

export function recordSaveCoordinatorEvent(type: 'parked' | 'failed'): void {
  if (type === 'parked') counters.parked++
  else counters.failed++
}

export function recordSaveRetryInvoked(): void {
  counters.retries++
}

export function getSaveTelemetry(): SaveTelemetry {
  return { ...counters }
}

/** Test helper */
export function resetSaveTelemetry(): void {
  counters = { parked: 0, failed: 0, retries: 0 }
}
